import React, { createContext, useState, useContext, useEffect } from "react";

import { getStoredState, updateStoredState } from "../utils/localStorage";

const UsersContext = createContext();

export const UsersProvider = ({ children }) => {
  const [users, setUsers] = useState(() => getStoredState()?.users || []);

  useEffect(() => {
    updateStoredState({ users });
  }, [users]);

  return (
    <UsersContext.Provider value={{ users, setUsers }}>
      {children}
    </UsersContext.Provider>
  );
};

export const useRole = () => useContext(UsersContext);
